import { render, staticRenderFns } from "./ScrollingPage.vue?vue&type=template&id=453068f5&"
import script from "./ScrollingPage.vue?vue&type=script&lang=js&"
export * from "./ScrollingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports